import { useState, useRef, useContext } from "react";
import { ReactSession } from "react-client-session";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getSuccessToast, getErrorToast } from "../../toast.js";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.jsx";
import EntriesDataContext from "../../context/EntriesDataContext.jsx";
import { Box, InputLabel, Select, MenuItem } from "@mui/material";
import "./Details.css";
import { returnTypeFinder, isReturnTypeDisabled } from "../../constants.js";

const Details = () => {
  // eslint-disable-next-line no-unused-vars
  const { setRedirectId } = useContext(EntriesDataContext);
  const axiosPrivate = useAxiosPrivate();
  const [medicineData, setMedicineData] = useState([]);
  const [batchNo, setBatchNo] = useState("");
  const [medicineName, setMedicineName] = useState("");
  const [expStatVal, setExpStatVal] = useState("");
  const [resetVal, setResetVal] = useState(false);
  const materialNoInputRef = useRef();
  const mfgDateInputRef = useRef();
  const expDateInputRef = useRef();
  const mrpInputRef = useRef();
  const quantityInputRef = useRef();
  const dateInputRef = useRef();
  const [returnType, setReturnType] = useState({
    value: "",
    disabled: true,
    returnOptions: [],
  });
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  today = dd + "/" + mm + "/" + yyyy;

  // useEffect(() => {
  //   batchNoRef.current.focus();
  // }, []);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  const clearHandler = (e) => {
    e.preventDefault();
    setBatchNo("");
    setMedicineName("");
    setResetVal(!resetVal);
    materialNoInputRef.current.value = "";
    mfgDateInputRef.current.value = "";
    expDateInputRef.current.value = "";
    mrpInputRef.current.value = "";
    quantityInputRef.current.value = "";
    dateInputRef.current.value = "";
    quantityInputRef.current.value = "";
    // expiryStatusRef.current.value = "";
    // expiryBtnRef.current.checked = false;
    setReturnType({
      value: "",
      disabled: true,
      returnOptions: [],
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!ReactSession.get("medicine_id")) {
      getErrorToast("Please select the batch number from the dropdown!");
      document.querySelector(".MuiAutocomplete-input").focus();
      return;
    }
    if (
      quantityInputRef.current.value === "0" ||
      quantityInputRef.current.value === undefined ||
      quantityInputRef.current.value == ""
    ) {
      getErrorToast("Unit is required.");
      return;
    }
    if (quantityInputRef.current.value <= "0") {
      getErrorToast("Unit should not be negative.");
      return;
    }
    if (quantityInputRef.current.value > 0) {
      const data = {
        medicine_master: ReactSession.get("medicine_id"),
        quantity: quantityInputRef.current.value,
        predicted_text: "test_string",
        by_ai: false,
        created_by: 1,
        updated_by: 1,
        stockists_master: ReactSession.get("box_id"),
        goods_type: returnType.value,
      };

      axiosPrivate.post("/data_entry/manual_entry/", data).then((res) => {
        // batchNoRef.current.focus();

        if (res.status === 201) {
          getSuccessToast("Medicine added successfully", 2000);
          setRedirectId((prevData) => prevData + 1);
        }
      });
      setBatchNo("");
      setMedicineData([]);
      setMedicineName("");
      materialNoInputRef.current.value = "";
      mfgDateInputRef.current.value = "";
      expDateInputRef.current.value = "";
      mrpInputRef.current.value = "";
      quantityInputRef.current.value = "";
      dateInputRef.current.value = "";
      quantityInputRef.current.value = "";
      setReturnType({
        value: "",
        disabled: true,
        returnOptions: [],
      });
      ReactSession.remove("medicine_id");
      setMedicineData([]);
      setResetVal(!resetVal);
      setTimeout(() => {
        document.querySelector(".MuiAutocomplete-input").focus();
      }, 0);
    } else {
      getErrorToast("Quantity required");
      quantityInputRef.current.focus();
    }
  };

  const handlerReason = (event) => {
    setReturnType((prev) => ({
      ...prev,
      value: event.target.value,
    }));
  };

  const fetchDataHandler = (e, val) => {
    setBatchNo(val);
    if (val.length >= 1) {
      try {
        axiosPrivate
          .get(`/data_entry/batch_number/?search=${val}`)
          .then((res) => {
            setMedicineData(res.data);
          });
      } catch (e) {
        console.error(e);
      }
    }
  };

  const fetchDataHandlerByMedicineName = (e, val) => {
    setMedicineName(val);
    if (val.length > 5) {
      try {
        axiosPrivate
          .get(`/data_entry/medicine_name/?search=${val}`)
          .then((res) => {
            setMedicineData(res.data);
          });
      } catch (e) {
        console.log(e);
      }
    }
  };

  const setDataHandler = (e, val) => {
    let bno = val["batch_number"];
    let desc = val["description"];
    let mrp = val["mrp"];

    if (bno.length > 1) {
      const filteredData = medicineData.filter(
        (med) =>
          med["batch_number"].trim() === bno &&
          med["description"].trim() === desc &&
          med["mrp"] === mrp
      )[0];

      if (filteredData !== undefined) {
        setBatchNo(filteredData["batch_number"]);
        setMedicineName(filteredData["description"]);
        materialNoInputRef.current.value = filteredData["material"];
        mfgDateInputRef.current.value = formatDate(
          filteredData["manufacture_date"]
        );
        expDateInputRef.current.value = formatDate(
          filteredData["date_of_expiry"]
        );
        mrpInputRef.current.value = filteredData["mrp"];
        dateInputRef.current.value = today;
        setReturnType({
          value: filteredData["goods_type"],
          disabled: isReturnTypeDisabled(
            filteredData["goods_type"],
            filteredData["cold_storage"]
          ),
          returnOptions: returnTypeFinder(
            filteredData["goods_type"],
            filteredData["cold_storage"]
          ),
        });
        setExpStatVal(filteredData["goods_type"]);
        quantityInputRef.current.focus();
        ReactSession.set("medicine_id", filteredData["medicine_master_id"]);
      }
    }
  };

  return (
    <div className="enter-details-container">
      <h4 className="enter-details-header">Enter Details</h4>

      <form onSubmit={submitHandler}>
        <section className="enter-details-input-section">
          <span className="enter-details-input-box enter-details-batch-input-box">
            <label htmlFor="batchno">Batch Number</label>
            {/* <input
              id="datalist-input"
              required
              ref={batchNoRef}
              list="batchno"
              className="enter-details-input enter-details-batch-input"
              onChange={changeHandler}
              onKeyDown={onKeyDownHandler}
              // onClick={dropDownAPI}
            />
            <datalist id="batchno">
              {medicineData.map((med, idex) => {
                return (
                  <option
                    key={idex}
                    // value={`${med.batch_number} ${med.description} `}
                    value={`${med.batch_number} ${med.description} ${med.mrp}`}
                  />
                );
              })}
            </datalist> */}
            <Autocomplete
              key={resetVal}
              inputValue={batchNo}
              disablePortal
              clearOnBlur={false}
              options={medicineData}
              clearOnEscape={true}
              className="enter-details-input-autocomplete enter-details-batch-input"
              sx={{
                width: "15vw",
                textTransform: "uppercase",
                "& .css-1krl8tb-MuiFormControl-root-MuiTextField-root": {
                  height: "1.75em",
                },
                "& .MuiAutocomplete-hasPopupIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root":
                  {
                    height: "1.75em",
                  },
                "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                  fontWeight: "600",
                  top: "-8px",
                  fontSize: "0.65em",
                },
                "& .MuiOutlinedInput-root": {
                  height: "1.75em",
                },
                "& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator":
                  {
                    display: "none",
                  },
                "& .MuiAutocomplete-input": {
                  position: "absolute",
                  width: "80% !important",
                },
                '&[data-focus="false"]': {
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                },
                '&[aria-selected="false"]': {
                  borderColor: "transparent",
                },
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              getOptionLabel={(option) => option.batch_number}
              renderOption={(props, medicineData) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {medicineData["batch_number"]} | {medicineData["description"]}{" "}
                  | {medicineData["date_of_expiry"]}
                </Box>
              )}
              onChange={(event, value) => setDataHandler(event, value)}
              onInputChange={(e, val) => fetchDataHandler(e, val)}
              renderInput={(params) => <TextField {...params} label="" />}
            />
          </span>

          <span className="enter-details-input-box enter-details-material-input-box">
            <label htmlFor="materialno">Material Description</label>
            <Autocomplete
              key={resetVal}
              inputValue={medicineName}
              disablePortal
              clearOnBlur={false}
              options={medicineData}
              clearOnEscape={true}
              className="enter-details-input-autocomplete enter-details-batch-input"
              sx={{
                width: "15vw",
                textTransform: "uppercase",
                "& .css-1krl8tb-MuiFormControl-root-MuiTextField-root": {
                  height: "1.75em",
                },
                "& .MuiAutocomplete-hasPopupIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon.css-13xad1h-MuiAutocomplete-root .MuiOutlinedInput-root":
                  {
                    height: "1.75em",
                  },
                "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                  fontWeight: "600",
                  top: "-8px",
                  fontSize: "0.65em",
                },
                "& .MuiOutlinedInput-root": {
                  height: "1.75em",
                },
                "& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator":
                  {
                    display: "none",
                  },
                "& .MuiAutocomplete-input": {
                  position: "absolute",
                  width: "80% !important",
                },
                '&[data-focus="false"]': {
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                },
                '&[aria-selected="false"]': {
                  borderColor: "transparent",
                },
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              getOptionLabel={(option) => option.description}
              renderOption={(props, medicineData) => (
                <Box
                  key={`${medicineData["description"]} ${
                    0 + medicineData["mrp"]
                  }`}
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {medicineData["description"]} | {medicineData["batch_number"]}{" "}
                  | {medicineData["date_of_expiry"]}
                </Box>
              )}
              onChange={(event, value) => setDataHandler(event, value)}
              onInputChange={(e, val) => fetchDataHandlerByMedicineName(e, val)}
              renderInput={(params) => <TextField {...params} />}
            />
          </span>
          <span className="enter-details-input-box enter-details-material-no-input-box">
            <label htmlFor="material-no">Material Code</label>
            <input
              required
              className="enter-details-input"
              id="material-no"
              type="text"
              placeholder="Product Code"
              disabled={true}
              ref={materialNoInputRef}
            />
          </span>
          <span className="enter-details-input-box enter-details-quantity-input-box">
            <label htmlFor="quantity">Quantity</label>
            <input
              required
              className="enter-details-input"
              id="quantity"
              type="number"
              step="any"
              placeholder="quantity"
              ref={quantityInputRef}
            />
          </span>
          <span className="enter-details-input-box enter-details-mrp-input-box">
            <label htmlFor="mrp">MRP</label>
            <input
              required
              className="enter-details-input"
              id="mrp"
              type="text"
              placeholder="MRP"
              disabled={true}
              ref={mrpInputRef}
            />
          </span>
          {/* <span className="enter-details-input-box enter-details-expiry-status-input-box">
            <label htmlFor="expiry-status">Expiry Status</label>
            <input
              required
              id="expiry-status"
              className="enter-details-input"
              type="text"
              placeholder="Status"
              disabled={true}
              ref={expiryStatusRef}
            />
          </span> */}
          {/* <span className="enter-details-input-box enter-details-breakage-input-box">
            <label htmlFor="breakage">Breakage</label>
            <input
              className="enter-details-input"
              id="breakage"
              type="checkbox"
              onChange={checkBoxHandler}
              disabled={true}
              ref={expiryBtnRef}
            />
          </span> */}
          <span className="enter-details-input-box enter-details-breakage-input-box">
            <InputLabel id="dropdown-label">Resone</InputLabel>
            <Select
              labelId="dropdown-label"
              id="dropdown"
              value={returnType.value}
              onChange={handlerReason}
              sx={{ width: 200, height: 32 }}
              disabled={returnType.disabled}
              required
            >
              {returnType.returnOptions.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </span>
          <span className="enter-details-input-box enter-details-mfg-input-box">
            <label htmlFor="mfg">MFG Date</label>
            <input
              required
              className="enter-details-input"
              id="mfg"
              type="text"
              placeholder="Mfg Date"
              disabled={true}
              ref={mfgDateInputRef}
            />
          </span>
          <span className="enter-details-input-box enter-details-expiry-input-box">
            <label htmlFor="expiry">Expiry Date</label>
            <input
              required
              className="enter-details-input"
              id="expiry"
              type="text"
              placeholder="Expiry Date"
              disabled={true}
              ref={expDateInputRef}
            />
          </span>

          <span className="enter-details-input-box enter-details-date-input-box">
            <label htmlFor="date">Date</label>
            <input
              required
              className="enter-details-input"
              id="date"
              type="text"
              placeholder="date"
              disabled={true}
              ref={dateInputRef}
            />
          </span>
        </section>

        <section className="enter-details-button-section">
          <button
            onClick={clearHandler}
            className="button enter-details-button enter-details-clear-button"
            type="button"
          >
            Clear
          </button>
          <button className="button enter-details-button enter-details-submit-button">
            Submit
          </button>
        </section>
      </form>
    </div>
  );
};

export default Details;
